import { useState, useEffect } from 'react';

function useSimulationCountQuery(customerSimulationId: string) {
    const [countQuery, setCountQuery] = useState({});

    useEffect(() => {
        if (customerSimulationId?.length) {
            setCountQuery({
                measures: [
                    'SimulationTpp.uniqueTransactionCount',
                    'SimulationTpp.uniqueAcceptedCount',
                    'SimulationTpp.uniqueRejectedCount'
                ],
                filters: [
                    {
                        member: 'SimulationTpp.simId',
                        operator: 'equals',
                        values: [customerSimulationId]
                    }
                ]
            });
        }
    }, [customerSimulationId]);

    return { countQuery };
}

export default useSimulationCountQuery;
